import { statuses } from '../constants';

export const LEADER_BOARD_RACES_LIST = 'races-list';

export const TABS_ORDER = [
    statuses.ACTIVE,
    statuses.NOT_STARTED,
    statuses.COMPLETED
];

export const RACES_ORDER = {
    default: 'default',
    startDate: 'start_date',
    endDate: 'end_date',
    registrationDate: 'registration_date'
};

export const NOTIFICATION_FIELDS = [
    'leaderboardId',
    'status',
    'registrationStatus',
    'leaderboardRules',
    'bannerUrl',
    'leaderboardStartTime',
    'millisecondsTillLeaderboardStart',
    'leaderboardEndTime',
    'millisecondsTillLeaderboardEnd',
    'status',
    'joined',
    'rank',
    'score',
    'eventCount',
    'eventCountLimit',
    'displayName',
    'customAttributes',
    'gamingContextRules',
    'participantsCount'
];

